(ns manatee.components.question-text
  (:require [clojure.string :as str]
            [manatee.admin.task-config.subs :as task-config-subs]
            [manatee.domain.task :as task]
            [manatee.ui.subs :as ui-subs]
            [re-frame.core :as rf]
            [rothko.markdown.core :as markdown]))

(defn preformatted-text
  [text]
  (->> (str/split text #"\n\n")
       (mapv (fn [s] [:p.preformatted-text s]))
       (into [:<>])))

(defn with-markdown
  [text]
  (let [markdown (-> text
                     (str/replace "www." "www<!--no-link!-->.")
                     (str/replace "http://" "http<!--no-link!-->://"))]
    (markdown/with-markdown {} markdown)))

(defn question-text
  [{:keys [task-config-id] {:keys [text]} :question :as _item}]
  (let [task-config @(rf/subscribe [::task-config-subs/task-config task-config-id])
        {:keys [account-ids]} @(rf/subscribe [::ui-subs/config])]
    (if (= :wandi (task/account task-config account-ids))
      [preformatted-text text]
      [:div.default-style-in-markdown (with-markdown text)])))
